/* @flow strict */

import * as React from 'react';
import ProgressButton from './react-progress-button';

import './style.css';

type BtnLoaderPropsType = {
  label: string,
  handleCallBack: () => void,
  disabled?: any
};

const BtnLoader = (props: BtnLoaderPropsType): React.Element<'button'> => {
  const [status, setStatus] = React.useState(''); // loading, success, error
  const click = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.preventDefault();

    props.handleCallBack(e, setStatus);
  };

  return (
    <ProgressButton
      state={props.disabled ? 'disabled' : status}
      onClick={click}
      controlled
    >
      {props.label}
    </ProgressButton>
  );
};

export default BtnLoader;
